import { render, staticRenderFns } from "./ManagementCard.vue?vue&type=template&id=dc39dabc"
import script from "./ManagementCard.vue?vue&type=script&lang=js"
export * from "./ManagementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports